var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("main", { staticClass: "login" }, [
    _c("div", { staticClass: "login-container" }, [
      _c("div", { staticClass: "login-block" }, [
        _c(
          "div",
          { staticClass: "login-block__logo" },
          [_c("Icon", { attrs: { icon: "logo" } })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.resetPassword && !_vm.passwordUpdateRequired,
                expression: "!resetPassword && !passwordUpdateRequired",
              },
            ],
            staticClass: "login-block__form",
          },
          [
            _c(
              "el-form",
              {
                ref: "ruleForm",
                attrs: {
                  model: _vm.ruleForm,
                  rules: _vm.rules,
                  "hide-required-asterisk": true,
                },
                nativeOn: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.submitForm("ruleForm")
                  },
                },
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.rememberPassword
                        ? "Email address"
                        : "Please enter your Email to receive a link to reset your Password",
                      prop: "email",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { type: "text" },
                      model: {
                        value: _vm.ruleForm.email,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "email", $$v)
                        },
                        expression: "ruleForm.email",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.rememberPassword
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "Password", prop: "password" } },
                      [
                        _c("el-input", {
                          attrs: { type: "password", autocomplete: "off" },
                          model: {
                            value: _vm.ruleForm.password,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "password", $$v)
                            },
                            expression: "ruleForm.password",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.serverError
                  ? _c("div", {
                      staticClass: "server-error",
                      domProps: { innerHTML: _vm._s(_vm.serverError) },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          "native-type": "submit",
                          loading: _vm.isSubmitting,
                        },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.rememberPassword ? "Login" : "Submit") +
                            "\n            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.resetPassword,
                expression: "resetPassword",
              },
            ],
            staticClass: "reset-block__form",
          },
          [
            _c(
              "el-form",
              {
                ref: "ruleResetForm",
                attrs: {
                  model: _vm.ruleResetForm,
                  rules: _vm.resetRules,
                  "hide-required-asterisk": true,
                },
                nativeOn: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.submitForm("ruleResetForm")
                  },
                },
              },
              [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.resetPassword,
                        expression: "!resetPassword",
                      },
                    ],
                    attrs: {
                      label: _vm.rememberPassword
                        ? "Email address"
                        : "Please enter your Email to receive a link to reset your Password",
                      prop: "email",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { type: "text" },
                      model: {
                        value: _vm.ruleForm.email,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "email", $$v)
                        },
                        expression: "ruleForm.email",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.resetPassword
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "New Password", prop: "password" } },
                      [
                        _c("el-input", {
                          attrs: { type: "password", autocomplete: "off" },
                          model: {
                            value: _vm.ruleResetForm.password,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleResetForm, "password", $$v)
                            },
                            expression: "ruleResetForm.password",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.resetPassword
                  ? _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "Confirm Password",
                          prop: "confirmPassword",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: { type: "password", autocomplete: "off" },
                          model: {
                            value: _vm.ruleResetForm.confirmPassword,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.ruleResetForm,
                                "confirmPassword",
                                $$v
                              )
                            },
                            expression: "ruleResetForm.confirmPassword",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.serverError
                  ? _c("div", {
                      staticClass: "server-error",
                      domProps: { innerHTML: _vm._s(_vm.serverError) },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          "native-type": "submit",
                          loading: _vm.isSubmitting,
                        },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.resetPassword ? "Submit" : "Login") +
                            "\n            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.passwordUpdateRequired
          ? _c(
              "div",
              { staticClass: "password-update-block" },
              [
                _c(
                  "div",
                  { staticClass: "el-form-item__label short-password-notice" },
                  [
                    _vm._v(
                      "\n          Short password detected - your password must be at least 6 characters long.\n          Please change your password to continue:\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "passwordUpdateForm",
                    attrs: {
                      model: _vm.ruleUpdateForm,
                      rules: _vm.updateRules,
                    },
                    nativeOn: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.submitPasswordUpdateForm.apply(
                          null,
                          arguments
                        )
                      },
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "Current Password",
                          prop: "currentPassword",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: { type: "password", autocomplete: "off" },
                          model: {
                            value: _vm.ruleUpdateForm.currentPassword,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.ruleUpdateForm,
                                "currentPassword",
                                $$v
                              )
                            },
                            expression: "ruleUpdateForm.currentPassword",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "New Password", prop: "newPassword" } },
                      [
                        _c("el-input", {
                          attrs: { type: "password", autocomplete: "off" },
                          model: {
                            value: _vm.ruleUpdateForm.newPassword,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleUpdateForm, "newPassword", $$v)
                            },
                            expression: "ruleUpdateForm.newPassword",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "Confirm New Password",
                          prop: "confirmNewPassword",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: { type: "password", autocomplete: "off" },
                          model: {
                            value: _vm.ruleUpdateForm.confirmNewPassword,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.ruleUpdateForm,
                                "confirmNewPassword",
                                $$v
                              )
                            },
                            expression: "ruleUpdateForm.confirmNewPassword",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.serverError
                      ? _c("div", {
                          staticClass: "server-error",
                          domProps: { innerHTML: _vm._s(_vm.serverError) },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              "native-type": "submit",
                              disabled: !_vm.updateFormValid,
                              loading: _vm.isSubmitting,
                            },
                          },
                          [
                            _vm._v(
                              "\n              Update Password\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.resetPassword && !_vm.passwordUpdateRequired
          ? _c("div", { staticClass: "login-block__link" }, [
              _c("p", { on: { click: _vm.forgotPassword } }, [
                _vm._v("Forgot password?"),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "login-info" }, [
        _c("div", { staticClass: "login-info__content" }, [
          _c(
            "div",
            { staticClass: "login-info__title" },
            [
              _c("TitleBlock", {
                attrs: {
                  text: "PC Getting started",
                  color: "brightblue",
                  size: "small",
                  type: "alternative",
                  padding: false,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "login-info__text" }, [
            _c("div", { staticClass: "login-info__text-title" }, [
              _vm._v("Existing subscribers"),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n            You should have received an email with a new username and\n            password. If you haven’t,\n            "
              ),
              _c("span", { on: { click: _vm.forgotPassword } }, [
                _vm._v("click here"),
              ]),
              _vm._v(
                " to request a new\n            one, or contact your Account Manager.\n          "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "login-info__text-title login-info__text-title--margin-top",
              },
              [_vm._v("\n            Not a subscriber?\n          ")]
            ),
            _vm._v(" "),
            _vm._m(0),
          ]),
          _vm._v(" "),
          _vm._m(1),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c(
        "a",
        {
          attrs: {
            href: "https://www.vixio.com/request-a-demo",
            target: "_blank",
          },
        },
        [_vm._v("Click here")]
      ),
      _vm._v(
        "\n            to learn more about VIXIO PaymentsCompliance\n          "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "login-info__text" }, [
      _c("div", { staticClass: "login-info__text-title" }, [
        _vm._v(
          "\n            How can our Horizon Scanning solution help you?\n          "
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n            Get access to a comprehensive, personalised feed of the latest\n            regulatory updates, sourced daily from thousands of regulatory\n            bodies across multiple jurisdictions and languages.\n          "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }